import React from 'react';
// import PointLoginLogo from './../../../resources/RTCC/point_club_logo.jpg'
export const Button = (props) => {
    return (
        <button
            disabled={props.disabled}
            onClick={props.onClick}
            type="submit"
            className={props.className}
            tabIndex={props.tabIndex}
        >
            <p className={props.buttonClassName}> {props.buttonText}</p>

        </button>
    );
}